import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SignupFormState, SignupOutletContext } from '../../components/signup/types';
import { loadExternalScript } from 'shared-utils/utils/loadExternalScript';
import { initializePartnerStack, PARTNER_STACK_SCRIPT_ID, PARTNER_STACK_SCRIPT_SRC } from '../../utils/partnerStack';
import { extractUtmParams } from '../../utils';

const SignupInitialPage = () => {
  const [formState, setFormState] = useState<SignupFormState>({});
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const utmParams = extractUtmParams(searchParams);
    const gclid = searchParams.get('gclid');

    const paramsToStore = {
      ...utmParams,
      ...(gclid ? { google_ad_click_id: gclid } : {}),
    };

    if (Object.keys(paramsToStore).length > 0) {
      setFormState((prev) => ({ ...paramsToStore, ...prev }));
    }
  }, [location.search]);

  useEffect(() => {
    loadExternalScript({
      id: 'hs-script-loader',
      src: '//js.hs-scripts.com/50110428.js',
      defer: true,
      type: 'text/javascript',
    }).catch((error) => {
      console.error('Failed to load HubSpot script', error);
    });

    loadExternalScript({
      id: PARTNER_STACK_SCRIPT_ID,
      src: PARTNER_STACK_SCRIPT_SRC,
      type: 'text/javascript',
    })
      .then(() => {
        initializePartnerStack();
      })
      .catch((error) => {
        console.error('Failed to load PartnerStack script', error);
      });
  }, []);

  const updateFormState = (updates: Partial<SignupFormState>) => {
    setFormState((prev) => ({ ...prev, ...updates }));
  };

  const outletContext: SignupOutletContext = {
    formState,
    updateFormState,
  };

  return <Outlet context={outletContext} />;
};

export default SignupInitialPage;
